import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { events } from "../events";

axios.defaults.baseURL = process.env.APP_URL;

axios.interceptors.request.use(
    (response) => {
        events.$emit("progress-loader", true);
        return response;
    },
    (error) => {
        events.$emit("progress-loader", true);
        return Promise.reject(error);
    },
    () => {}
);

axios.interceptors.response.use(
    (response) => {
        events.$emit("progress-loader", false);
        return response;
    },
    (error) => {
        events.$emit("progress-loader", false);
        events.$emit("toastify", error);

        return Promise.reject(error);
    }
);

Vue.use(VueAxios, axios);

export default (app) => {
    app.axios = axios;
    app.$http = axios;

    app.config.globalProperties.axios = axios;
    app.config.globalProperties.$http = axios;
}
